
import { Button } from "@/components/ui/button";
import { GlassCard } from "@/components/ui/glass-card";
import { useNavigate } from "react-router-dom";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { AlertTriangle, ArrowLeft } from "lucide-react";
import { PWAInstallPrompt } from "@/components/pwa/install-prompt";

interface GameVoteTeamNotFoundProps {
  error: string;
  teamName: string | null;
  teamFound: boolean;
  onBackClick: () => void;
  showPWAPrompt?: boolean;
}

export function GameVoteTeamNotFound({ 
  error, 
  teamName, 
  teamFound, 
  onBackClick,
  showPWAPrompt = false 
}: GameVoteTeamNotFoundProps) {
  console.log("GameVoteTeamNotFound - Rendering with:", {
    error,
    teamName,
    teamFound,
    showPWAPrompt
  });
  
  return (
    <div className="max-container px-4 py-8">
      <Button 
        variant="ghost" 
        onClick={onBackClick}
        className="mb-4 gap-1 ps-0"
        size="sm"
      >
        <ArrowLeft className="h-4 w-4" />
        <span>Back to Home</span>
      </Button>
      
      <GlassCard className="max-w-lg mx-auto">
        <div className="text-center p-6">
          <AlertTriangle className="h-12 w-12 text-amber-500 mx-auto mb-4" />
          <h2 className="text-xl font-semibold mb-4">
            {teamFound ? "No Active Polls" : "Team Not Found"}
          </h2>
          
          <Alert variant="destructive" className="mb-6 text-start">
            <AlertDescription>{error}</AlertDescription>
          </Alert>
          
          <p className="text-muted-foreground mb-6">
            {teamFound 
              ? `You can try again later, or contact the coach to set up a new poll for ${teamName || 'this team'}.`
              : "Please check the URL and try again."}
          </p>
          
          <Button onClick={onBackClick}>Return to Home</Button>
        </div>
      </GlassCard>
      
      {showPWAPrompt && <PWAInstallPrompt />}
    </div>
  );
}
